module.exports = __webpack_public_path__ + "static/transparency_cnclogo-f784ea56858855901f65d5635289600c.png";